import {
  customersGridColumnFromIndex,
  customersGridLastRowStackZIndex,
  customersGridRowBorderClass,
  customersGridRowFromIndex,
} from "@/components/blocks/customers-grid-layout";

/** Shared TrustedCustomersGrid card styles (server-safe — no "use client"). */
export const TRUSTED_CUSTOMERS_GRID_CARD =
  "-ml-px flex min-w-0 rounded-2xl border border-grey-100 bg-grey-0 p-4";

/** Grid shell — must span Container columns so cells don't collapse to min-content. */
export const TRUSTED_CUSTOMERS_GRID = "col-span-full grid gap-0";

export {
  customersGridColumnFromIndex,
  customersGridLastRowStackZIndex,
  customersGridRowBorderClass,
  customersGridRowFromIndex,
};
